import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { createHook, createStore } from 'react-sweet-state';
import { HttpError, teamsClient } from '@atlassian/teams-client';
import { transformPermissions } from './utils';
var actions = {
  getPermissions: function getPermissions(_ref, _ref2) {
    var orgId = _ref.orgId,
      cloudId = _ref.cloudId,
      enabled = _ref.enabled;
    var onFetch = _ref2.onFetch;
    return /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref3) {
        var setState, getState, dispatch, _getState, hasLoaded, isLoading, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              setState = _ref3.setState, getState = _ref3.getState, dispatch = _ref3.dispatch;
              _getState = getState(), hasLoaded = _getState.hasLoaded, isLoading = _getState.isLoading;
              if (!(hasLoaded || isLoading || !enabled || !orgId || !cloudId)) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              _context.prev = 4;
              setState({
                isLoading: true
              });
              teamsClient.setContext({
                orgId: orgId,
                cloudId: cloudId
              });
              _context.next = 9;
              return teamsClient.getPermissions();
            case 9:
              response = _context.sent;
              dispatch(actions.setPermissions(response.permissions));
              onFetch === null || onFetch === void 0 || onFetch();
              _context.next = 17;
              break;
            case 14:
              _context.prev = 14;
              _context.t0 = _context["catch"](4);
              dispatch(actions.setError(_context.t0 instanceof HttpError ? _context.t0 : new Error('Failed to fetch permissions')));
            case 17:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[4, 14]]);
      }));
      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }();
  },
  setError: function setError(error) {
    return function (_ref5) {
      var setState = _ref5.setState;
      setState({
        hasLoaded: true,
        isLoading: false,
        error: error
      });
    };
  },
  setLoading: function setLoading(isLoading) {
    return function (_ref6) {
      var setState = _ref6.setState;
      setState({
        isLoading: isLoading
      });
    };
  },
  setPermissions: function setPermissions(permissions) {
    return function (_ref7) {
      var setState = _ref7.setState;
      setState({
        hasLoaded: true,
        isLoading: false,
        permissions: transformPermissions(permissions),
        permissionsResponse: {
          permissions: permissions
        }
      });
    };
  }
};
var Store = createStore({
  initialState: {
    error: undefined,
    hasLoaded: false,
    isLoading: false,
    permissions: {
      canCreateTeams: true,
      canViewTeams: true,
      canAdminTeams: false
    }
  },
  actions: actions,
  name: 'teams-permissions'
});
export var useTeamsPermissionsStore = createHook(Store);